import { Box, Button, Dialog, Stack, Typography } from "@compass/core";
import { UploadFile } from "generated/openApi";
import { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import { initDataModel } from "utils";

export const StudentSignature = (props: {
  open: boolean;
  close: () => void;
  signatureFile: UploadFile;
  done: (value: UploadFile) => void;
}) => {
  const signatureRef = useRef<SignatureCanvas>(null);
  const validated = signatureRef.current && signatureRef.current.isEmpty() === false;
  const [, forceUpdate] = useState<any>();

  // useEffect(() => {
  //   setService(props.service);
  // }, [props.service]);

  const done = () => {
    const signatureFile = initDataModel<UploadFile>({
      fileName: "Student_Signature.png",
      fileSize: undefined,
      uploadingData: signatureRef?.current?.getTrimmedCanvas().toDataURL("image/png"),
    });
    props.done(signatureFile);
  };

  const clearSignature = () => {
    signatureRef.current?.clear();
    forceUpdate({});
  };

  return (
    <Dialog
      open={props.open}
      maxWidth="sm"
      header={
        <Stack direction="row" alignItems={"center"} justifyContent={"space-between"}>
          <Typography variant="inherit">Participant Signature</Typography>
          <Stack direction="row" spacing="sm">
            <Button onClick={() => props.close()} onTouchEnd={() => props.close()}>Cancel</Button>
            <Button
              variant="contained"
              onClick={() => {
                done();
                props.close();
              }}
              disabled={!validated}
            >
              Add
            </Button>
          </Stack>
        </Stack>
      }
      content={
        <Stack spacing="sm">
          <Stack>
            <Stack
              border={1}
              borderColor={(theme) => theme.palette.border.dark}
              spacing="sm"
              bgcolor={(theme) => theme.palette.background.default}
              alignItems="center"
            >
              <Box sx={{ width: 350, height: 200 }} bgcolor={(theme) => theme.palette.background.paper}>
                <SignatureCanvas
                  penColor="black"
                  ref={signatureRef}
                  canvasProps={{ width: 350, height: 200 }}
                  onEnd={() => forceUpdate({})}
                />
              </Box>
            </Stack>

            <Stack direction="row" justifyContent={"flex-end"} alignItems="center">
              <Button onClick={() => clearSignature()}>Clear</Button>
            </Stack>
          </Stack>
        </Stack>
      }
    />
  );
};
